import React from 'react'
import { cn } from "../../../lib/utils";

const remixiconUrl = `/assets/icon/remixicon.symbol.svg`;
export interface IEditorMenuItem { icon?: string, title?: string, action?: () => any, isActive?: () => boolean | null, type?: string }
const EditorMenuItem: React.FC<IEditorMenuItem> = ({ icon, title, action, isActive = null }) => (
  <button tabIndex={-1}
    className={cn(
      "flex items-center justify-center p-1 w-7 h-7 rounded shrink-0 transition-colors text-muted-foreground hover:bg-muted/80 hover:text-foreground outline-none",
      isActive && isActive() && "bg-muted text-foreground font-semibold"
    )}
    onClick={action}
    title={title}
  >
    <svg className="w-4 h-4 fill-current">
      <use xlinkHref={`${remixiconUrl}#ri-${icon}`} />
    </svg>
  </button>
)

export default EditorMenuItem;